import { ProductOrBrand } from "./alternativeTypes";

export const electronicsProducts: ProductOrBrand[] = [
  {
    name: "HP",
    ownerCountry: "US",
    categories: ["electronics", "computers"],
  },
  {
    name: "Dell",
    ownerCountry: "US",
    categories: ["electronics", "computers"],
  },
  {
    name: "Apple",
    ownerCountry: "US",
    categories: ["electronics", "phones", "computers"],
  },
  {
    name: "JBL",
    ownerCountry: "US",
    categories: ["electronics", "audio"],
  },
  {
    name: "Bose",
    ownerCountry: "US",
    categories: ["electronics", "audio"],
  },
  {
    name: "Sonos",
    ownerCountry: "US",
    categories: ["electronics", "audio"],
  },
  {
    name: "Fitbit",
    ownerCountry: "US",
    categories: ["electronics", "wearables"],
  },
  {
    name: "Garmin",
    ownerCountry: "US",
    categories: ["electronics", "wearables"],
  },
  {
    name: "Tuxedo Computers",
    ownerCountry: "DE",
    notAvailableIn: ["CA"],
    categories: ["electronics", "computers"],
  },
  {
    name: "Cepter by Power",
    ownerCountry: "NO",
    availableIn: ["NO", "FI", "DK", "SE"],
    categories: ["electronics", "computers"],
  },
  {
    name: "Punkt.",
    ownerCountry: "CH",
    headquarterIn: "CH",
    availableIn: ["CH", "DE", "FR", "IT", "UK", "ES", "NL", "SE", "NO", "DK", "FI", "AT", "BE", "LU"],
    comments: "Swiss consumer electronics company founded in 2008, known for minimalist design and products that encourage digital detox, such as simple mobile phones and alarm clocks.",
    categories: ["electronics", "phones"],
    sourceLinks: ["https://www.punkt.ch/en/", "https://creativesupply.com/en/resources/punkt/"]
  },
  {
    name: "Fairphone",
    ownerCountry: "NL",
    categories: ["electronics", "phones"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Fairphone"],
  },
  {
    name: "Jolla",
    ownerCountry: "FI",
    categories: ["electronics", "phones"],
    sourceLinks: ["https://jolla.com/"],
  },
  {
    name: "Nothing",
    ownerCountry: "UK",
    categories: ["electronics", "phones"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Nothing_(company)"],
  },
  {
    name: "Jabra",
    ownerCountry: "DK",
    categories: ["electronics", "audio"],
    sourceLinks: ["https://www.jabra.com/"],
  },
  {
    name: "psb speakers",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["electronics", "audio"],
    sourceLinks: ["https://www.psbspeakers.com"],
  },
  {
    name: "Withings",
    ownerCountry: "FR",
    categories: ["electronics", "wearables"],
    sourceLinks: ["https://www.withings.com/no/no/"],
  },
  {
    name: "Logitech",
    ownerCountry: "CH",
    categories: ["electronics", "audio"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Logitech"
    ],
  },  
  
  {
    name: "Polar",
    ownerCountry: "FI",
    categories: ["electronics", "wearables"],
    sourceLinks: ["https://www.polar.com/"],
  },
];